import { formDataRequest, postRequest } from '../libs/AxiosService.util';

export async function serviceCreateRole(params) {
    return await formDataRequest('roles/create', params);
}

export async function serviceUpdateRole(params) {
    return await formDataRequest('roles/update', params);
}

export async function serviceFetchRoles(params) {
    return await postRequest("roles", params);
}

export async function serviceRoleDetail(params) {
    return await postRequest("roles/detail", params);
}
export async function serviceDeleteRole(params) {
    return await postRequest("roles/delete", params);
}

export async function serviceRoleIsExist (params) {  
    return await postRequest('roles/check', params);
}
export async function serviceAssociatedUsersRole (params) {  
    return await postRequest('roles/users', params);
}